import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useSettings } from "../context/SettingsProvider";
import "./StaticPage.css";

function DevelopersPage() {
    const { settings } = useSettings();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <main className="main-content">
            <Helmet>
                <title>Developers - {settings?.site_name || "Play Store"}</title>
                <meta name="description" content="Join our developer community and publish your apps" />
            </Helmet>

            <div className="static-page-container">
                <div className="page-header">
                    <h1>Developer Resources</h1>
                    <p className="page-subtitle">Build, publish, and grow your apps with {settings?.site_name}</p>
                </div>

                <div className="page-content">
                    <section className="content-section">
                        <h2>🚀 Why Develop With Us?</h2>
                        <div className="feature-grid">
                            <div className="feature-card">
                                <div className="feature-icon">📱</div>
                                <h3>Easy Publishing</h3>
                                <p>Simple and streamlined app submission process</p>
                            </div>
                            <div className="feature-card">
                                <div className="feature-icon">📊</div>
                                <h3>Analytics Dashboard</h3>
                                <p>Track downloads, ratings, and user engagement</p>
                            </div>
                            <div className="feature-card">
                                <div className="feature-icon">🌍</div>
                                <h3>Global Reach</h3>
                                <p>Reach millions of users worldwide</p>
                            </div>
                        </div>
                    </section>

                    <section className="content-section">
                        <h2>📚 Developer Resources</h2>
                        <ul className="resource-list">
                            <li><strong>Documentation:</strong> Comprehensive guides and API references</li>
                            <li><strong>Support:</strong> Dedicated developer support team</li>
                            <li><strong>Community:</strong> Active developer forums and discussions</li>
                        </ul>
                    </section>

                    <section className="content-section">
                        <h2>🎯 Getting Started</h2>
                        <ol className="steps-list">
                            <li>Create a developer account</li>
                            <li>Prepare your app for submission</li>
                            <li>Submit your app for review</li>
                            <li>Publish and promote your app</li>
                        </ol>
                    </section>

                    <div className="cta-section">
                        <h2>Ready to Get Started?</h2>
                        <p>Join thousands of developers already publishing on {settings?.site_name}</p>
                        <a href="/panel/developer/register" className="cta-button">
                            Become a Developer
                        </a>
                    </div>
                </div>
            </div>
        </main>
    );
}

export default DevelopersPage;
